// 使用通用布局的路由配置

export default [
  {
    name: "",
    redirect: "warranty-list",
    meta: {
      title: "延保管理",
      icon: "reorder",
    },
    children: [
      {
        name: "warranty-list",
        component: () => import("@/views/Warranty/list"),
        meta: {
          title: "延保管理",
        },
      },
      {
        name: "serial-list",
        component: () => import("@/views/Serial/list"),
        meta: {
          title: "序列号列表",
        },
      },
      {
        name: "model-list",
        component: () => import("@/views/Serial/modelList"),
        meta: {
          title: "型号管理",
        },
      },
      {
        name: "model-create",
        component: () => import("@/views/Serial/modelForm"),
        meta: {
          title: "添加型号",
        },
        hidden: true,
      },
      {
        name: "warranty-explain-agreement",
        component: () => import("@/views/Settings/banner-form"),
        meta: {
          title: "延保说明",
          stage: "warranty-explain",
          name: "agreement",
        },
      },
    ],
  },
  {
    name: "product",
    redirect: "list",
    meta: {
      title: "产品管理",
      icon: "queue_music",
    },
    children: [
      {
        name: "list",
        component: () => import("@/views/Product/list"),
        meta: {
          title: "产品列表",
        },
      },
      {
        name: "add",
        component: () => import("@/views/Product/form"),
        meta: {
          title: "添加产品",
        },
        hidden: true,
      },
      {
        name: "edit",
        component: () => import("@/views/Product/form"),
        meta: {
          title: "编辑产品",
        },
        params: ["id"],
        hidden: true,
      },

      {
        name: "series-list",
        component: () => import("@/views/Settings/series-list"),
        meta: {
          title: "产品系列",
          stage: "series-list",
          name: "series-list",
        },
      },
      {
        name: "series-add",
        component: () => import("@/views/Settings/series-form"),
        meta: {
          title: "添加产品系列",
        },
        hidden: true,
      },
      {
        name: "series-edit",
        component: () => import("@/views/Settings/series-form"),
        meta: {
          title: "编辑产品系列",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "features-list",
        component: () => import("@/views/Settings/features-list"),
        meta: {
          title: "产品功能",
          stage: "features-list",
          name: "features-list",
        },
      },
      {
        name: "features-add",
        component: () => import("@/views/Settings/features-form"),
        meta: {
          title: "添加产品功能",
        },
        hidden: true,
      },
      {
        name: "features-edit",
        component: () => import("@/views/Settings/features-form"),
        meta: {
          title: "编辑产品功能",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "instructions-list",
        component: () => import("@/views/Settings/instructions-list"),
        meta: {
          title: "产品说明书",
          stage: "instructions-list",
          name: "instructions-list",
        },
      },
      {
        name: "instructions-add",
        component: () => import("@/views/Settings/instructions-form"),
        meta: {
          title: "添加产品说明书",
        },
        hidden: true,
      },
      {
        name: "instructions-edit",
        component: () => import("@/views/Settings/instructions-form"),
        meta: {
          title: "编辑产品说明书",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "recommends-list",
        component: () => import("@/views/Settings/recommends-list"),
        meta: {
          title: "商品推荐",
          stage: "recommends-list",
          name: "recommends-list",
        },
      },
      {
        name: "recommends-add",
        component: () => import("@/views/Settings/recommends-form"),
        meta: {
          title: "添加商品推荐",
        },
        hidden: true,
      },
      {
        name: "recommends-edit",
        component: () => import("@/views/Settings/recommends-form"),
        meta: {
          title: "编辑商品推荐",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "search-log",
        component: () => import("@/views/Settings/search-log"),
        meta: {
          title: "搜索历史",
          stage: "search-log",
          name: "search-log",
        },
      },
    ],
  },
  {
    name: "settings",
    meta: {
      title: "页面设置",
      icon: "settings_applications",
    },
    redirect: "new-product",
    children: [
      {
        name: "banner-list",
        component: () => import("@/views/Banner/index"),
        meta: {
          title: "banner列表",
        },
      },
      {
        name: "banner-add",
        component: () => import("@/views/Banner/form"),
        meta: {
          title: "添加banner",
        },
        hidden: true,
      },
      {
        name: "banner-edit",
        component: () => import("@/views/Banner/form"),
        meta: {
          title: "编辑banner",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "new-product",
        component: () => import("@/views/Settings/new-product-list"),
        meta: {
          title: "新品速递",
        },
      },
      {
        name: "new-product-edit",
        component: () => import("@/views/Settings/new-product-form"),
        meta: {
          title: "编辑广告",
        },
        params: ["index", "type"],
        hidden: true,
      },
      {
        name: "home-setting",
        component: () => import("@/views/Settings/home"),
        meta: {
          title: "小程序首页",
        },
      },
      {
        name: "brand-history-page-banner",
        component: () => import("@/views/Settings/banner-form"),
        meta: {
          title: "品牌历史管理",
          stage: "brand-history",
          name: "page-banner",
        },
      },
      {
        name: "protocol",
        component: () => import("@/views/Settings/protocol-form"),
        meta: {
          title: "注册协议",
          stage: "protocol",
          name: "protocol",
        },
      },
      {
        name: "member-equity-page-banner",
        component: () => import("@/views/Settings/banner-form"),
        meta: {
          title: "会员权益",
          stage: "member-equity",
          name: "page-banner",
        },
      },
      {
        name: "navigation-bars-list",
        component: () => import("@/views/Settings/navigation-bars-list"),
        meta: {
          title: "首页导航栏",
          stage: "navigation-bars-list",
          name: "navigation-bars-list",
        },
      },
      {
        name: "navigation-bars-add",
        component: () => import("@/views/Settings/navigation-bars-form"),
        meta: {
          title: "添加首页导航栏",
        },
        hidden: true,
      },
      {
        name: "navigation-bars-edit",
        component: () => import("@/views/Settings/navigation-bars-form"),
        meta: {
          title: "编辑首页导航栏",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "keyword-list",
        component: () => import("@/views/Settings/keyword-list"),
        meta: {
          title: "关键词",
          stage: "keyword-list",
          name: "keyword-list",
        },
      },
      {
        name: "keyword-add",
        component: () => import("@/views/Settings/keyword-form"),
        meta: {
          title: "添加关键词",
        },
        hidden: true,
      },
      {
        name: "keyword-edit",
        component: () => import("@/views/Settings/keyword-form"),
        meta: {
          title: "编辑关键词",
        },
        params: ["id"],
        hidden: true,
      },
      // {
      //     name: 'templates-list',
      //     component: () => import('@/views/Settings/templates-list'),
      //     meta: {
      //         title: '产品参数模版',
      //         stage: 'templates-list',
      //         name: 'templates-list'
      //     }
      // },
      // {
      //     name: 'templates-add',
      //     component: () => import('@/views/Settings/templates-form'),
      //     meta: {
      //         title: '添加产品参数模版'
      //     },
      //     hidden: true
      // },
      // {
      //     name: 'templates-edit',
      //     component: () => import('@/views/Settings/templates-form'),
      //     meta: {
      //         title: '编辑产品参数模版'
      //     },
      //     params: ['id'],
      //     hidden: true
      // }
      {
        name: "special-page",
        component: () => import("@/views/Settings/special-page"),
        meta: {
          title: "专题配置",
        },
      },
      {
        name: "special-page-add",
        component: () => import("@/views/Settings/special-page-edit"),
        meta: {
          title: "专题页面添加",
          useLayout: false,
        },
        hidden: true,
      },
      {
        name: "special-page-edit",
        component: () => import("@/views/Settings/special-page-edit"),
        meta: {
          title: "专题页面编辑",
          useLayout: false,
        },
        hidden: true,
      },
      {
        name: "special-page-view",
        component: () => import("@/views/Settings/special-page-edit"),
        meta: {
          title: "查看页面设置",
          useLayout: false,
        },
        hidden: true,
      },
    ],
  },
  // {
  //   name: "video",
  //   redirect: "list",
  //   meta: {
  //     title: "视频管理",
  //     icon: "ondemand_video",
  //   },
  //   children: [
  //     {
  //       name: "main-video-cover",
  //       component: () => import("@/views/Settings/banner-form"),
  //       meta: {
  //         title: "主打视频封面",
  //         stage: "main-video",
  //         name: "video-cover",
  //       },
  //     },
  //     {
  //       name: "video-index",
  //       component: () => import("@/views/Settings/video-index"),
  //       meta: {
  //         title: "视频集合页",
  //         stage: "video-index",
  //         name: "top-banner",
  //       },
  //     },
  //     {
  //       name: "list",
  //       component: () => import("@/views/Video/list"),
  //       meta: {
  //         title: "视频列表",
  //       },
  //     },
  //     {
  //       name: "edit",
  //       params: ["id"],
  //       component: () => import("@/views/Video/form"),
  //       meta: {
  //         title: "修改封面",
  //       },
  //       hidden: true,
  //     },
  //     {
  //       name: "add",
  //       component: () => import("@/views/Video/form"),
  //       meta: {
  //         title: "上传视频",
  //       },
  //       hidden: true,
  //     },
  //     {
  //       name: "cate-list",
  //       component: () => import("@/views/Video/cateList"),
  //       meta: {
  //         title: "视频分类",
  //       },
  //     },
  //     {
  //       name: "cate-add",
  //       component: () => import("@/views/Video/cateForm"),
  //       meta: {
  //         title: "添加视频分类",
  //       },
  //       hidden: true,
  //     },
  //     {
  //       name: "cate-edit",
  //       component: () => import("@/views/Video/cateForm"),
  //       params: ["id"],
  //       meta: {
  //         title: "编辑视频分类",
  //       },
  //       hidden: true,
  //     },
  //   ],
  // },
  {
    name: "casio-video",
    redirect: "list",
    meta: {
      title: "视频管理",
      icon: "ondemand_video",
    },
    children: [
      {
        name: "cate-list",
        component: () => import("@/views/CasioVideo/cateList"),
        meta: {
          title: "视频分类",
        },
        out: true,
      },
      {
        name: "statistics-list",
        component: () => import("@/views/CasioVideo/list"),
        meta: {
          title: "视频列表",
        },
        out: true,
      },
      {
        name: "edit",
        params: ["id"],
        component: () => import("@/views/CasioVideo/form"),
        meta: {
          title: "编辑视频",
        },
        hidden: true,
      },
      {
        name: "add",
        component: () => import("@/views/CasioVideo/form"),
        meta: {
          title: "上传视频",
        },
        hidden: true,
      },
      {
        name: "cate-add",
        component: () => import("@/views/CasioVideo/cateForm"),
        meta: {
          title: "添加视频分类",
        },
        hidden: true,
      },
      {
        name: "cate-edit",
        component: () => import("@/views/CasioVideo/cateForm"),
        params: ["id"],
        meta: {
          title: "编辑视频分类",
        },
        hidden: true,
      },
    ],
  },
  {
    name: "user",
    redirect: "list",
    meta: {
      title: "会员管理",
      icon: "people",
    },
    children: [
      {
        name: "list",
        component: () => import("@/views/User/index"),
        meta: {
          title: "会员列表",
        },
      },
      {
        name: "credit-task",
        component: () => import("@/views/Task/credit-task"),
        meta: {
          title: "积分任务",
        },
      },
    ],
  },
  {
    name: "admin",
    redirect: "list",
    meta: {
      title: "管理员",
      icon: "check_circle",
    },
    children: [
      {
        name: "list",
        component: () => import("@/views/Admin/index"),
        meta: {
          title: "管理员列表",
        },
      },
      {
        name: "create",
        component: () => import("@/views/Admin/form"),
        hidden: true,
        meta: {
          title: "添加管理员",
        },
      },
    ],
  },
  {
    name: "dataReport",
    redirect: "list",
    meta: {
      title: "数据报表",
      icon: "ondemand_video",
    },
    children: [
      {
        name: "list",
        component: () => import("@/views/DataReport/activtyData"),
        meta: {
          title: "暑促活动数据",
        },
        out: true,
      },
    ],
  },
  {
    name: "music",
    redirect: "score-list",
    meta: {
      title: "曲谱管理",
      icon: "ondemand_video",
    },
    children: [
      {
        name: "score-list",
        component: () => import("@/views/Music/score"),
        meta: {
          title: "曲谱列表",
        },
      },
      {
        name: "song-list",
        params: ["id"],
        hidden: true,
        component: () => import("@/views/Music/song"),
        meta: {
          title: "曲目管理",
        },
      },
      {
        name: "code-list",
        params: ["id"],
        hidden: true,
        component: () => import("@/views/Music/code"),
        meta: {
          title: "兑换码管理",
        },
      },
      {
        name: "accompaniment-list",
        component: () => import("@/views/Music/accompaniment"),
        meta: {
          title: "伴奏管理",
        },
      },
      {
        name: "play-list",
        component: () => import("@/views/Music/play"),
        meta: {
          title: "演奏视频管理",
        },
      },
      {
        name: "overhead-list",
        component: () => import("@/views/Music/overhead"),
        meta: {
          title: "俯拍视频管理",
        },
      },
    ],
  },
  {
    name: "credit-shop",
    redirect: "category-list",
    meta: {
      title: "积分商城",
      icon: "assignment_late",
    },
    children: [
      {
        name: "category-list",
        component: () => import("@/views/CreditShop/category"),
        meta: {
          title: "商品分类",
        },
        out: true,
      },
      {
        name: "credit-goods-list",
        component: () => import("@/views/CreditShop/list"),
        meta: {
          title: "积分商品",
        },
        out: true,
      },
      {
        name: "credit-goods-form",
        component: () => import("@/views/CreditShop/form"),
        meta: {
          title: "添加积分商品",
        },
        hidden: true,
      },
    ],
  },
  {
    name: "gift",
    redirect: "gift-list",
    meta: {
      title: "礼品",
      icon: "ondemand_video",
    },
    children: [
      {
        name: "gift-list",
        component: () => import("@/views/Gift/list"),
        meta: {
          title: "全部礼品",
        },
      },
      {
        name: "add",
        component: () => import("@/views/Gift/detail"),
        meta: {
          title: "新增礼品",
        },
        hidden: true,
      },
      {
        name: "edit",
        component: () => import("@/views/Gift/detail"),
        meta: {
          title: "全部礼品",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "stock",
        component: () => import("@/views/Gift/stock"),
        meta: {
          title: "礼品库存",
        },
      },
      {
        name: "lemon-music-code-list",
        component: () => import("@/views/Gift/lemon-music-code-list"),
        meta: {
          title: "柠檬音乐券",
        },
      },
      {
        name: "course-code-list",
        component: () => import("@/views/Gift/course-code-list"),
        meta: {
          title: "yooba音乐兑换码",
        },
      },
    ],
  },
  {
    name: "interaction",
    redirect: "sign-activity",
    meta: {
      title: "互动",
      icon: "ondemand_video",
    },
    children: [
      {
        name: "sign-activity",
        component: () => import("@/views/Interaction/sign-activity"),
        meta: {
          title: "签到有礼",
        },
      },
      {
        name: "sign-add",
        component: () => import("@/views/Interaction/sign-detail"),
        meta: {
          title: "新增签到有礼",
        },
        hidden: true,
      },
      {
        name: "sign-edit",
        component: () => import("@/views/Interaction/sign-detail"),
        meta: {
          title: "编辑签到有礼",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "sign-preview",
        component: () => import("@/views/Interaction/sign-detail"),
        meta: {
          title: "查看签到有礼",
        },
        hidden: true,
      },
      {
        name: "activity-data",
        component: () => import("@/views/Interaction/activity-data"),
        meta: {
          title: "活动数据",
        },
        hidden: true,
      },
      {
        name: "invite-activity",
        component: () => import("@/views/Interaction/invite-activity"),
        meta: {
          title: "邀请有礼",
        },
      },
      {
        name: "invite-add",
        component: () => import("@/views/Interaction/invite-detail"),
        meta: {
          title: "新增邀请有礼",
        },
        hidden: true,
      },
      {
        name: "invite-edit",
        component: () => import("@/views/Interaction/invite-detail"),
        meta: {
          title: "编辑邀请有礼",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "invite-preview",
        component: () => import("@/views/Interaction/invite-detail"),
        meta: {
          title: "查看邀请有礼",
        },
        hidden: true,
      },
      {
        name: "share-activity",
        component: () => import("@/views/Interaction/share-activity"),
        meta: {
          title: "分享有礼",
        },
      },
      {
        name: "share-add",
        component: () => import("@/views/Interaction/share-detail"),
        meta: {
          title: "新增分享有礼",
        },
        hidden: true,
      },
      {
        name: "share-edit",
        component: () => import("@/views/Interaction/share-detail"),
        meta: {
          title: "编辑分享有礼",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "share-preview",
        component: () => import("@/views/Interaction/share-detail"),
        meta: {
          title: "查看分享有礼",
        },
        hidden: true,
      },
      {
        name: "sign-preview",
        component: () => import("@/views/Interaction/invite-detail"),
        meta: {
          title: "查看签到有礼",
        },
        hidden: true,
      },
      {
        name: "register-activity",
        component: () => import("@/views/Interaction/register-activity"),
        meta: {
          title: "入会有礼",
        },
      },
      {
        name: "register-activity-add",
        component: () => import("@/views/Interaction/register-activity-detail"),
        meta: {
          title: "新增入会有礼",
        },
        hidden: true,
      },
      {
        name: "register-activity-edit",
        component: () => import("@/views/Interaction/register-activity-detail"),
        meta: {
          title: "编辑入会有礼",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "register-activity-view",
        component: () => import("@/views/Interaction/register-activity-detail"),
        meta: {
          title: "查看入会有礼",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "lucky-turntable",
        component: () => import("@/views/Interaction/lucky-turntable"),
        meta: {
          title: "幸运大转盘",
        },
      },
      {
        name: "lucky-turntable-add",
        component: () => import("@/views/Interaction/lucky-turntable-detail"),
        meta: {
          title: "新增大转盘",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "lucky-turntable-edit",
        component: () => import("@/views/Interaction/lucky-turntable-detail"),
        meta: {
          title: "编辑大转盘",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "lucky-turntable-preview",
        component: () => import("@/views/Interaction/lucky-turntable-detail"),
        meta: {
          title: "查看大转盘",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "lucky-turntable-data",
        component: () => import("@/views/Interaction/lucky-activity-data"),
        meta: {
          title: "大转盘数据",
        },
        params: ["id"],
        hidden: true,
      },

      {
        name: "award-questionnaire",
        component: () => import("@/views/Interaction/award-questionnaire/list"),
        meta: {
          title: "有奖调查",
        },
      },
      {
        name: "award-questionnaire-add",
        component: () =>
          import("@/views/Interaction/award-questionnaire/detail"),
        meta: {
          title: "新增有奖调查",
        },
        hidden: true,
      },
      {
        name: "award-questionnaire-edit",
        component: () =>
          import("@/views/Interaction/award-questionnaire/detail"),
        meta: {
          title: "编辑有奖调查",
        },
        hidden: true,
      },
      {
        name: "award-questionnaire-preview",
        component: () =>
          import("@/views/Interaction/award-questionnaire/detail"),
        meta: {
          title: "查看有奖调查",
        },
        hidden: true,
      },
      {
        name: "award-questionnaire-data",
        component: () => import("@/views/Interaction/award-questionnaire/data"),
        meta: {
          title: "有奖调查数据",
        },
        hidden: true,
      },
      {
        name: "award-questionnaire-data-detail",
        component: () =>
          import("@/views/Interaction/award-questionnaire/data-detail"),
        meta: {
          title: "有奖调查数据详情",
        },
        hidden: true,
      },
    ],
  },
  {
    name: "order",
    redirect: "material",
    meta: {
      title: "订单",
      icon: "ondemand_video",
    },
    children: [
      {
        name: "material",
        component: () => import("@/views/Order/material"),
        meta: {
          title: "实物订单",
        },
      },
      {
        name: "material-detail",
        component: () => import("@/views/Order/material-detail"),
        meta: {
          title: "实物订单详情",
        },
        params: ["id"],
        hidden: true,
      },
      {
        name: "fictitious",
        component: () => import("@/views/Order/fictitious"),
        meta: {
          title: "虚拟订单",
        },
      },
      {
        name: "fictitious-detail",
        component: () => import("@/views/Order/fictitious-detail"),
        meta: {
          title: "虚拟订单详情",
        },
        params: ["id"],
        hidden: true,
      },
    ],
  },
  {
    name: "store",
    redirect: "store-list",
    meta: {
      title: "线下门店",
      icon: "reorder",
    },
    children: [
      {
        name: "store-list",
        component: () => import("@/views/Store/list"),
        meta: {
          title: "门店列表",
        },
        out: true,
      },
    ],
  },
];
